import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import classnames from 'classnames';

const customStyles = {
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    top: '0px',
    bottom: 'auto',
    border: 'none',
    backgroundColor: 'transparent',
    overflow: 'visible',
  },
};

export default createReactClass({
  propTypes: {
    children: PropTypes.element.isRequired,
    isOpen: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      isOpen: false,
    };
  },

  componentWillMount() {
    Modal.setAppElement('#react-modal');
  },

  componentDidMount() {
    this.bodyScroll(!this.props.isOpen);
  },

  componentWillReceiveProps(props) {
    this.bodyScroll(!props.isOpen);
  },

  componentWillUnmount() {
    this.bodyScroll(true);
  },

  bodyScroll(enabled) {
    document.getElementsByTagName('body')[0].style.overflow = (enabled) ? null : 'hidden';
  },

  render() {
    const {className, ...props} = this.props;
    const modalClassName = classnames('modal-dialog', className);

    return (
      <Modal className={modalClassName} style={customStyles} {...props} >
        {this.props.children}
      </Modal>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/components/Modal.js